import { render } from "./ThirdNotification.vue?vue&type=template&id=38b60e60&scoped=true&ts=true"
import script from "./ThirdNotification.vue?vue&type=script&lang=ts"
export * from "./ThirdNotification.vue?vue&type=script&lang=ts"

import "./ThirdNotification.vue?vue&type=style&index=0&id=38b60e60&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b60e60"]])

export default __exports__